import { useEffect, useState } from 'react';

import { intervalToDuration } from 'date-fns';
import styled from 'styled-components';

import { colors } from 'theme/colors';

import { urgencyOfferDecodedTTL } from 'utils/urgencyOfferUtils';

export const Wrapper = styled.div`
  display: inline-block;
  width: auto;
  padding: 0 1rem;
  height: 1.5rem;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: bold;
  text-shadow: none;
  line-height: 1.5rem;
  border-radius: 1.5rem;
  box-shadow: none;
  margin-top: 15px;
  margin-bottom: 15px;
  color: ${colors.white};
  background-color: ${colors['content-primary']};
  border: none;
  text-align: center;
  box-sizing: border-box;
`;

const timeOver = timeLeft => {
  return (
    timeLeft.hours === 0 &&
    timeLeft.minutes === 0 &&
    timeLeft.seconds === 0
  );
};

export function LiveTimerPill() {
  const expirationDate = new Date(urgencyOfferDecodedTTL * 1000);

  const calculateTimeLeft = () => {
    return new Date() >= expirationDate
      ? { hours: 0, minutes: 0, seconds: 0 }
      : intervalToDuration({ start: new Date(), end: expirationDate });
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      const timeLeft = calculateTimeLeft();
      setTimeLeft(timeLeft);
      if (timeOver(timeLeft)) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  });

  const formatTimeLeft = duration => {
    const day_to_hours = duration.days * 24;
    const hours = (duration.hours + day_to_hours).toString().padStart(2, '0');
    const minutes = duration.minutes.toString().padStart(2, '0');
    const seconds = duration.seconds.toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };
  return <Wrapper>{'Bonus ends in ' + formatTimeLeft(timeLeft)}</Wrapper>;
}
